module.exports = __webpack_public_path__ + "static/media/Overbite (deep bite)9.3997668b.png";